"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorNotificationDTOSchema = exports.NotificationRequestDTOSchema = exports.NotificationDTO = exports.NotificationDTOSchema = exports.NotificationSchema = exports.NotificationBaseSchema = exports.NOTIFICATION_TYPE = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var User_1 = require("./User");
var NOTIFICATION_TYPE;
(function (NOTIFICATION_TYPE) {
    NOTIFICATION_TYPE["LIKE"] = "like";
    // FOLLOW = 'follow',
    NOTIFICATION_TYPE["COMMENT"] = "comment";
    NOTIFICATION_TYPE["FORUM_MODERATION"] = "forum_moderation";
    // MESSAGE = 'message',
    NOTIFICATION_TYPE["DOCUMENT"] = "document";
    NOTIFICATION_TYPE["TICKET"] = "ticket";
    NOTIFICATION_TYPE["SST"] = "sst";
    NOTIFICATION_TYPE["SST_EXCLUDE"] = "sst_exclude";
    NOTIFICATION_TYPE["DSRB"] = "dsrb";
    NOTIFICATION_TYPE["SST_REQUEST"] = "sstrequest";
})(NOTIFICATION_TYPE || (exports.NOTIFICATION_TYPE = NOTIFICATION_TYPE = {}));
exports.NotificationBaseSchema = zod_1.z.object({
    author: zod_1.z.instanceof(ObjectId_1.ObjectId),
    user: zod_1.z.instanceof(ObjectId_1.ObjectId),
    // Date when the notification was seen by the user
    dateSeen: zod_1.z.coerce.date().nullish().default(null),
    // Message to the user
    action: zod_1.z.string(),
    notificationType: zod_1.z.nativeEnum(NOTIFICATION_TYPE),
    // ObjectIf of the related entity
    notificationTypeId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    // Url no navigate
    url: zod_1.z.string().optional(),
});
exports.NotificationSchema = exports.NotificationBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
// Replace notificationType with string schema for DTOs
exports.NotificationDTOSchema = exports.NotificationSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields).extend({
    notificationTypeId: zod_1.z.string(),
});
exports.NotificationDTO = {
    convertFromModel: function (model) {
        var _a;
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            dateSeen: model.dateSeen,
            author: (0, ObjectId_1.isPopulated)(model.author)
                ? User_1.UserDTO.convertFromModel(model.author)
                : exports.AuthorNotificationDTOSchema.safeParse(model.author).success
                    ? model.author
                    : '',
            user: (0, ObjectId_1.isPopulated)(model.user) ? User_1.UserDTO.convertFromModel(model.user) : model.user.toString(),
            action: model.action,
            notificationType: model.notificationType,
            notificationTypeId: (_a = model.notificationTypeId) === null || _a === void 0 ? void 0 : _a.toString(),
            url: model.url ? model.url : '',
        };
        return dto;
    },
};
exports.NotificationRequestDTOSchema = exports.NotificationDTOSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelRequestDTOFields), { author: (0, ObjectId_1.ObjectIdString)('Invalid author id'), user: (0, ObjectId_1.ObjectIdString)('Invalid user id') }));
exports.AuthorNotificationDTOSchema = zod_1.z.object({
    _id: zod_1.z.string(),
    fullName: zod_1.z.string(),
    image: zod_1.z.string().nullish(),
});
//# sourceMappingURL=Notification.js.map